<template>
	<div id="prebuild-fps" class="prebuild-fps">
		<div class="prebuild-fps__resolution">
			<h6 class="prebuild-fps__heading">
				Performance
			</h6>
			<resolution-picker
				:current-resolution="getResolution"
				:set-resolution="gamesPerformance.setResolution"
			/>
		</div>

		<div class="prebuild-fps__games">
			<div :key="`game-${game.id}`" v-for="game in games">
				<game-fps :game="game" :resolution="getResolution" />
			</div>
		</div>

		<div v-if="showFpsPendingMobile" class="prebuild-fps__pending-fps-msg">
			<h5>FPS pending</h5>
			<p>{{ fpsPendingMessage }}</p>
		</div>
	</div>
</template>

<script>
import CONSTANTS from "@/config/constants";
import ResolutionPicker from "./resolution-picker";
import GameFps from "./game-fps";

export default {
	name: "PrebuildFps",
	components: {
		ResolutionPicker,
		GameFps
	},
	props: {
		gamesPerformance: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			fpsPendingMessage: CONSTANTS.FPS_PENDING_MESSAGE
		};
	},
	computed: {
		getResolution() {
			return this.gamesPerformance.resolution();
		},
		games() {
			const { getGames } = this.gamesPerformance;
			return getGames();
		},
		showFpsPendingMobile() {
			return this.games.some(game => game.fps[this.getResolution] == 0);
		}
	}
};
</script>

<style lang="scss" scoped>
.prebuild-fps {
	padding-top: 30px;

	&__resolution {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 15px;
	}

	&__heading {
		color: #444259;
		font-size: 14px;
		font-weight: bold;
		letter-spacing: 0;
		text-transform: uppercase;
		margin: 0;
	}

	&__games {
		display: flex;
		max-width: max-content;

		@media (min-width: 991px) {
			max-width: initial;
		}

		& > div:not(:last-child) {
			margin-right: 15px;
		}
	}

	&__pending-fps-msg {
		display: none;
		color: #5F707F;
		font-size: 16px;
		letter-spacing: 0;
		line-height: 21px;
		margin: 20px 0 10px;

		h5 {
			font-size: 16px;
			font-weight: bold;
			margin: 0 0 5px;
		}

		p {
			margin: 0;
		}

		@media (hover: none) {
			display: block;
		}
	}
}
</style>
